import { IMasterAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { propOr } from 'ramda';

export const getMasterAgentAvatar = (masterAgent?: IMasterAgentSchema): string =>
  propOr('', 'absoluteAvatarUrl', masterAgent);
